module.exports = __webpack_public_path__ + "media/images/emblems/Kueblis_wappen-0f34592b6d0605a279dec849fd427943.svg";